__turbopack_context__.v({
  "button": "LoadMoreButton-module-scss-module__si2oMW__button",
  "buttonContainer": "LoadMoreButton-module-scss-module__si2oMW__buttonContainer",
  "loadMoreButton": "LoadMoreButton-module-scss-module__si2oMW__loadMoreButton",
  "wrapper": "LoadMoreButton-module-scss-module__si2oMW__wrapper",
});
